import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPlus, FiGrid, FiUsers, FiClock, FiShare2 } = FiIcons;

function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <div className="container mx-auto px-4 py-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h1 className="text-5xl font-bold text-primary mb-4 font-rubik">
            Digitales Kreuzworträtsel
          </h1>
          <p className="text-xl text-primary max-w-3xl mx-auto mb-8 font-rubik">
            Erstelle interaktive Kreuzworträtsel und teile sie mit anderen. 
            Kein Login erforderlich - einfach erstellen und über URL teilen.
          </p>
          
          <Link to="/create">
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="bg-button hover:bg-button-hover text-white px-8 py-4 rounded-lg text-lg font-semibold flex items-center gap-3 mx-auto transition-colors font-rubik"
            >
              <SafeIcon icon={FiPlus} className="text-xl" />
              Neues Rätsel erstellen
            </motion.button>
          </Link>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto"
        >
          <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-200">
            <SafeIcon icon={FiGrid} className="text-3xl text-primary mb-4" />
            <h3 className="text-lg font-semibold text-primary mb-2 font-rubik">
              Automatische Gitter-Generierung
            </h3>
            <p className="text-primary font-rubik">
              Gib deine Hinweise und Lösungswörter ein - das Gitter wird automatisch erstellt
            </p>
          </div>

          <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-200">
            <SafeIcon icon={FiUsers} className="text-3xl text-primary mb-4" />
            <h3 className="text-lg font-semibold text-primary mb-2 font-rubik">
              Multiplayer-Modus
            </h3>
            <p className="text-primary font-rubik">
              Mehrere Personen können gleichzeitig am selben Rätsel arbeiten
            </p>
          </div>

          <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-200">
            <SafeIcon icon={FiShare2} className="text-3xl text-primary mb-4" />
            <h3 className="text-lg font-semibold text-primary mb-2 font-rubik">
              Einfaches Teilen
            </h3>
            <p className="text-primary font-rubik">
              Teile dein Rätsel über URL oder QR-Code - kein Login erforderlich
            </p>
          </div>

          <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-200">
            <SafeIcon icon={FiClock} className="text-3xl text-primary mb-4" />
            <h3 className="text-lg font-semibold text-primary mb-2 font-rubik">
              Automatische Löschung
            </h3>
            <p className="text-primary font-rubik">
              Sessions werden nach 365 Tagen Inaktivität automatisch gelöscht
            </p>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="text-center mt-12"
        >
          <h2 className="text-2xl font-semibold text-primary mb-4 font-rubik">
            So funktioniert's
          </h2>
          <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <div className="text-center">
              <div className="bg-button rounded-full w-12 h-12 flex items-center justify-center mx-auto mb-4">
                <span className="text-white font-bold text-lg">1</span>
              </div>
              <h3 className="font-semibold text-primary mb-2 font-rubik">Erstellen</h3>
              <p className="text-primary font-rubik">
                Gib deine Hinweise und Lösungswörter ein
              </p>
            </div>
            <div className="text-center">
              <div className="bg-button rounded-full w-12 h-12 flex items-center justify-center mx-auto mb-4">
                <span className="text-white font-bold text-lg">2</span>
              </div>
              <h3 className="font-semibold text-primary mb-2 font-rubik">Teilen</h3>
              <p className="text-primary font-rubik">
                Kopiere die URL oder zeige den QR-Code
              </p>
            </div>
            <div className="text-center">
              <div className="bg-button rounded-full w-12 h-12 flex items-center justify-center mx-auto mb-4">
                <span className="text-white font-bold text-lg">3</span>
              </div>
              <h3 className="font-semibold text-primary mb-2 font-rubik">Spielen</h3>
              <p className="text-primary font-rubik">
                Andere können sofort mitmachen und rätseln
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
}

export default HomePage;